import { AlertMessageModule } from '@shared/components';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { MultiAddToCartButtonComponent } from './multi-add-to-cart-button.component';
import { NgModule } from '@angular/core';
@NgModule({
	declarations: [MultiAddToCartButtonComponent],
	imports: [
		AlertMessageModule,
		CommonModule,
		FormsModule,
		HmfButtonComponent
	],
	exports: [MultiAddToCartButtonComponent]
})
export class MultiAddToCartButtonModule { }
